/* Only a temporary yes/no visit flag is kept; never a birth year or birthday. */
(function () {
  const key = 'bozu_age_visit_v1';
  const idleLimit = 30 * 60 * 1000;
  const pageId = Date.now().toString(36) + Math.random().toString(36).slice(2);
  let verified = false;
  let externalLink = false;
  let checkoutStartedAt = 0;

  function read() {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; }
  }

  function write(value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch { /* Stay gated on the next page if storage is unavailable. */ }
  }

  function isActive(state) {
    const elapsed = Date.now() - state?.lastSeen;
    return state?.verified === true && Number.isFinite(elapsed) && elapsed >= 0 && elapsed < idleLimit;
  }

  function pageUrl() {
    const url = new URL(location.href);
    url.hash = '';
    return url.href;
  }

  function verify() {
    verified = true;
    write({ verified: true, lastSeen: Date.now() });
    document.documentElement.classList.remove('bozu-age-pending');
  }

  function invalidate() {
    verified = false;
    try { sessionStorage.removeItem(key); } catch { /* The visible gate remains the fallback. */ }
    document.documentElement.classList.add('bozu-age-pending');
  }

  const state = read();
  const navigationType = performance.getEntriesByType('navigation')[0]?.type || 'navigate';
  let internalReferrer = false;
  try { internalReferrer = new URL(document.referrer).origin === location.origin; } catch { /* Direct entry has no referrer. */ }
  const continuation = isActive(state) && (
    navigationType === 'reload' ||
    (state.handoff && navigationType === 'navigate' && internalReferrer) ||
    (state.handoff && navigationType === 'back_forward' && (state.handoff.url !== pageUrl() || state.handoff.checkout))
  );
  if (continuation) verify();
  else invalidate();

  // A handoff is written only when this document actually leaves. Opening an
  // internal link in a new tab therefore does not inherit an automatic pass.
  window.addEventListener('pagehide', function () {
    const current = read();
    if (!verified || !isActive(current) || externalLink) return invalidate();
    write({
      verified: true,
      lastSeen: Date.now(),
      handoff: { pageId, url: pageUrl(), checkout: Date.now() - checkoutStartedAt < 10000 },
    });
  });

  function touch() {
    const current = read();
    if (verified && isActive(current) && Date.now() - current.lastSeen > 5000) {
      write({ verified: true, lastSeen: Date.now() });
    }
  }
  document.addEventListener('pointerdown', touch, { passive: true });
  document.addEventListener('keydown', touch);
  document.addEventListener('click', function (event) {
    externalLink = false;
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    externalLink = new URL(link.href, location.href).origin !== location.origin;
  }, true);

  window.BozuAgeVisit = {
    isVerified: function () { return verified; },
    verify,
    invalidate,
    markCheckout: function () { checkoutStartedAt = Date.now(); },
    restore: function () {
      const current = read();
      // A cached document returning from another storefront page continues the
      // visit. Returning to the same document after leaving the site starts anew.
      const continues = isActive(current) && current.handoff &&
        (current.handoff.pageId !== pageId || current.handoff.checkout);
      if (continues) verify();
      else invalidate();
      return !!continues;
    },
  };
})();
